import React from 'react';
import { Helmet } from "react-helmet";

const SEO = ({ title }) => {
  return (
    <Helmet>
      <title>Best Way Telecommunication and Networking company &#38; ..Creating advanced technology</title>
    </Helmet>
  );
};

export default SEO;
